import "./fieldError.css";

// Replaces the duplicated inline `<label style={{color:'red',...}}>`
// error styles scattered across every New*/​*Edit form.
export const FieldError = ({ children }) => {
  if (!children) return null;
  return <span className="admin-field-error">{children}</span>;
};
